import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const TOKEN_KEY = "lis_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeader = () => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

// Public
export const getServices = () => client.get("/services").then((r) => r.data);
export const getService = (id) => client.get(`/services/${id}`).then((r) => r.data);
export const getJobs = () => client.get("/jobs").then((r) => r.data);
export const getBlog = () => client.get("/blog").then((r) => r.data);
export const getBlogPost = (slug) => client.get(`/blog/${slug}`).then((r) => r.data);
export const getCaseStudies = () => client.get("/case-studies").then((r) => r.data);
export const getCaseStudy = (slug) => client.get(`/case-studies/${slug}`).then((r) => r.data);
export const getTestimonials = () => client.get("/testimonials").then((r) => r.data);
export const getClients = () => client.get("/clients").then((r) => r.data);
export const submitContact = (data) => client.post("/contact", data).then((r) => r.data);
export const submitApplication = (data) => client.post("/careers/apply", data).then((r) => r.data);
export const subscribeNewsletter = (email) => client.post("/newsletter", { email }).then((r) => r.data);

// Auth
export const login = (email, password) => client.post("/auth/login", { email, password }).then((r) => r.data);
export const fetchMe = () => client.get("/auth/me", { headers: authHeader() }).then((r) => r.data);

// Admin (protected)
export const getAdminContacts = () => client.get("/admin/contacts", { headers: authHeader() }).then((r) => r.data);
export const getAdminApplications = () => client.get("/admin/applications", { headers: authHeader() }).then((r) => r.data);
export const getAdminStats = () => client.get("/admin/stats", { headers: authHeader() }).then((r) => r.data);
export const updateContactStatus = (id, status) => client.patch(`/admin/contacts/${id}`, { status }, { headers: authHeader() }).then((r) => r.data);
export const updateApplicationStatus = (id, status) => client.patch(`/admin/applications/${id}`, { status }, { headers: authHeader() }).then((r) => r.data);

export const downloadExport = async (kind) => {
  const res = await client.get(`/admin/export/${kind}`, { headers: authHeader(), responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: "text/csv" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = kind === "contacts" ? "liinex-enquiries.csv" : "liinex-applications.csv";
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

// Admin content: case studies
export const adminListCaseStudies = () => client.get("/admin/case-studies", { headers: authHeader() }).then((r) => r.data);
export const adminCreateCaseStudy = (data) => client.post("/admin/case-studies", data, { headers: authHeader() }).then((r) => r.data);
export const adminUpdateCaseStudy = (id, data) => client.put(`/admin/case-studies/${id}`, data, { headers: authHeader() }).then((r) => r.data);
export const adminDeleteCaseStudy = (id) => client.delete(`/admin/case-studies/${id}`, { headers: authHeader() }).then((r) => r.data);

// Admin content: testimonials
export const adminListTestimonials = () => client.get("/admin/testimonials", { headers: authHeader() }).then((r) => r.data);
export const adminCreateTestimonial = (data) => client.post("/admin/testimonials", data, { headers: authHeader() }).then((r) => r.data);
export const adminUpdateTestimonial = (id, data) => client.put(`/admin/testimonials/${id}`, data, { headers: authHeader() }).then((r) => r.data);
export const adminDeleteTestimonial = (id) => client.delete(`/admin/testimonials/${id}`, { headers: authHeader() }).then((r) => r.data);

// Admin content: blog
export const adminListBlog = () => client.get("/admin/blog", { headers: authHeader() }).then((r) => r.data);
export const adminCreateBlog = (data) => client.post("/admin/blog", data, { headers: authHeader() }).then((r) => r.data);
export const adminUpdateBlog = (id, data) => client.put(`/admin/blog/${id}`, data, { headers: authHeader() }).then((r) => r.data);
export const adminDeleteBlog = (id) => client.delete(`/admin/blog/${id}`, { headers: authHeader() }).then((r) => r.data);

// Lead digest
export const sendDigest = () => client.post("/admin/digest/send", {}, { headers: authHeader() }).then((r) => r.data);
